"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignOutEverywhereResult = void 0;
const base_update_result_dto_1 = require("../../../../common/dtos/base-update-result.dto");
class SignOutEverywhereResult extends base_update_result_dto_1.BaseUpdateResult {
}
exports.SignOutEverywhereResult = SignOutEverywhereResult;
